import { Link } from 'react-router-dom';

function HomeHeroSection() {
  return (
    <section className="hero" id="top" aria-labelledby="hero-title">
      <div className="hero-bg" />
      <div className="wrap hero-inner">
        <h1 id="hero-title">Empowering Engineers to Innovate, Inspire, and Lead the Future</h1>
        <p className="lead">Guiding software professionals to grow into impactful tech leaders, forward-thinking architects, and AI-powered developers.</p>
        <Link className="btn btn-red" to="/workshop">Tell Me More</Link>
        <div className="hero-evolve">
          <h2>Are You Ready to Evolve?</h2>
          <p>We don't just teach code. We teach the mindset required to lead.</p>
        </div>
      </div>
    </section>
  );
}

export default HomeHeroSection;
